import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './polyfills';
import i18n from './i18n/config';

// Définition des types pour le Hot Module Replacement
declare global {
  interface Window {
    __REACT_DEVTOOLS_GLOBAL_HOOK__: any;
  }
}

// Désactiver les logs en production
if (process.env.NODE_ENV === 'production') {
  // Garder console.error et console.warn pour les vraies erreurs
}

// Déclaration du type pour module.hot
declare const module: {
  hot?: {
    accept(path: string, callback: () => void): void;
  };
};

// Site ouvert dans un navigateur Android : les barres fixes ignorent la
// marge env(safe-area-inset-bottom). Chrome Android la fait varier quand sa
// barre d'adresse apparaît ou disparaît (mode edge-to-edge décidé au
// chargement, viewport-fit=cover), d'où une nav du bas qui changeait de
// hauteur au scroll. Ici la barre système ne recouvre jamais la page.
// iOS (encoche, barre d'accueil) et l'app Capacitor gardent la marge.
if (/Android/i.test(navigator.userAgent) && !Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('android-web');
}

// S'assurer que l'élément root existe
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// Utiliser la nouvelle API createRoot pour React 18
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>
);

// Si vous voulez commencer à mesurer les performances dans votre application,
// passez une fonction pour consigner les résultats
reportWebVitals();

// Configuration du Hot Module Replacement (HMR) de manière sûre avec TypeScript
if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./App', () => {
    // Importer dynamiquement le nouveau composant App
    const NextApp = require('./App').default;
    // Utiliser la même instance de root pour le HMR
    root.render(
      <React.StrictMode>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
            <NextApp />
          </BrowserRouter>
        </I18nextProvider>
      </React.StrictMode>
    );
  });
}
